module.exports = __webpack_public_path__ + "static/media/jessica-testimonial.9fe34fec.png";